import api from './api';

// Private files are fetched with the admin session (never a public/signed link).
// The browser may cache them 30 min; "refresh" switches to a new URL to bypass that cache.
const BUST_KEY = 'yooin_admin_files_bust';

export const refreshPrivateFiles = () => sessionStorage.setItem(BUST_KEY, String(Date.now()));

export const fetchPrivateFile = async (path, extraParams) => {
  const bust = sessionStorage.getItem(BUST_KEY);
  const res = await api.get(path, { responseType: 'blob', params: { ...(bust ? { r: bust } : {}), ...extraParams } });
  return URL.createObjectURL(res.data);
};

export const openPrivateFile = async (path) => {
  const win = window.open('', '_blank');
  try {
    const url = await fetchPrivateFile(path);
    if (win) { win.opener = null; win.location.href = url; } else window.open(url, '_blank');
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (e) {
    if (win) win.close();
    throw e;
  }
};
